import * as React from 'react'
import { Dimensions, ScaledSize } from 'react-native'

const dimensions = Dimensions.get('window')

interface ResponsiveContextInterface {
  dims: ScaledSize
  setDims: React.Dispatch<React.SetStateAction<ScaledSize>>
}

export const ResponsiveContext = React.createContext<ResponsiveContextInterface>({
  dims: dimensions,
  setDims: () => {},
})

export const ResponsiveProvider: React.FunctionComponent<{}> = props => {
  // State variables
  const [dims, setDims] = React.useState(dimensions)

  // Callbacks and functions

  // useEffects

  return (
    <ResponsiveContext.Provider
      value={{
        dims,
        setDims,
      }}
    >
      {props.children}
    </ResponsiveContext.Provider>
  )
}

export const useResponsiveContext = () => React.useContext(ResponsiveContext)
